import { createContext } from 'react';

const CheckListContext = createContext<{
  value: string[];
  check: (val: string) => void;
  uncheck: (val: string) => void;
  disabled?: boolean;
  readOnly?: boolean;
  mode?: string;
} | null>(null);

export default CheckListContext;
